import Routes from './routes';
import './services/auditNotifications';

export default Routes;
